import React from 'react';
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import { COLORS } from '../constants';
import { SortDirection } from '../utils/timelineColumns';

// Compact table-style sort control: a tight up/down caret pair sitting next to a
// left-column header label. The active direction's caret is highlighted (navy);
// clicking a caret asks the parent to sort that way (and the parent clears the
// sort when the already-active caret is clicked again).
type Props = {
  // 'asc' | 'desc' when THIS column is the active sort, else null.
  active: SortDirection | null;
  onSort: (direction: SortDirection) => void;
};

const ACTIVE = COLORS.todayAccent; // brand navy
const INACTIVE = COLORS.headerSubtleText; // muted slate

const caretStyle = (lit: boolean): React.CSSProperties => ({
  display: 'block',
  fontSize: 9,
  lineHeight: '7px',
  height: 7,
  cursor: 'pointer',
  color: lit ? ACTIVE : INACTIVE,
});

const SortArrows: React.FC<Props> = ({ active, onSort }) => {
  const click = (direction: SortDirection) => (e: React.MouseEvent) => {
    // Headers can host other click targets (group-by dropdown nearby) — keep the
    // sort toggle from bubbling into them.
    e.preventDefault();
    e.stopPropagation();
    onSort(direction);
  };
  return (
    <span
      aria-hidden
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: '0 0 auto',
        marginLeft: 4,
      }}
    >
      <CaretUpFilled
        style={caretStyle(active === 'asc')}
        onClick={click('asc')}
      />
      <CaretDownFilled
        style={caretStyle(active === 'desc')}
        onClick={click('desc')}
      />
    </span>
  );
};

export default SortArrows;
